import methods from "../methods";
import { resolvePath, isObject } from "./utils";
const bodyMethods = [methods.PATCH, methods.POST, methods.PUT];
export default function mixin(serviceConfig, apiSchema, requestObj) {
    var _a, _b, _c;
    const apiSchemaURL = apiSchema.url;
    requestObj = requestObj || {};
    serviceConfig = serviceConfig || {};
    const apiSchemaURLInfo = Object.assign({}, apiSchemaURL);
    const apiSchemaInfo = {
        url: apiSchemaURLInfo,
    };
    const priority = Object.assign(Object.assign(Object.assign({
        preprocess: 100,
        postprocess: 100,
    }, (_a = serviceConfig === null || serviceConfig === void 0 ? void 0 : serviceConfig.config) === null || _a === void 0 ? void 0 : _a.priority), (_b = apiSchema === null || apiSchema === void 0 ? void 0 : apiSchema.config) === null || _b === void 0 ? void 0 : _b.priority), (_c = requestObj === null || requestObj === void 0 ? void 0 : requestObj.config) === null || _c === void 0 ? void 0 : _c.priority);
    apiSchemaInfo.config = Object.assign(Object.assign(Object.assign(Object.assign({}, serviceConfig === null || serviceConfig === void 0 ? void 0 : serviceConfig.config), apiSchema === null || apiSchema === void 0 ? void 0 : apiSchema.config), requestObj === null || requestObj === void 0 ? void 0 : requestObj.config), {
        priority,
    });
    if (apiSchema.mock || requestObj.mock) {
        apiSchemaInfo.mock = apiSchema.mock;
    }
    if (requestObj.path) {
        apiSchemaURLInfo.path = resolvePath(apiSchemaURL.path, requestObj.path);
    }
    if (serviceConfig.prefix) {
        apiSchemaURLInfo.path = serviceConfig.prefix + apiSchemaURLInfo.path;
    }
    if (apiSchemaURL.body || requestObj.body) {
        if (isObject(apiSchemaURL.body) || isObject(requestObj.body)) {
            apiSchemaURLInfo.body = Object.assign(Object.assign({}, apiSchemaURL.body), requestObj.body);
        }
        else {
            apiSchemaURLInfo.body = apiSchemaURL.body || requestObj.body;
        }
        if (process.env.NODE_ENV === "development") {
            if (!bodyMethods.includes(apiSchemaURLInfo.method)) {
                console.warn("HTTP methods like post,patch,put require a body.");
            }
        }
    }
    if (apiSchemaURL.query || requestObj.query) {
        apiSchemaURLInfo.query = Object.assign(Object.assign({}, apiSchemaURL.query), requestObj.query);
    }
    if (apiSchemaURL.headers || requestObj.headers || serviceConfig.headers) {
        apiSchemaURLInfo.headers = Object.assign(Object.assign(Object.assign({}, serviceConfig.headers), apiSchemaURL.headers), requestObj.headers);
    }
    return apiSchemaInfo;
}
